module.exports = __webpack_public_path__ + "media/images/swifticons/weather-rain-comment-4bc24a95022862abc2a142e0ae93463d.svg";